import React from 'react';
import { resendOtpCode } from '@vtblife/otp-api/axios-gen/otp_user_service';
import { useCountdownTimer } from '@search/classified-common/src/useCountdownTimer';
import { OtpSession } from '../../useSaveSearch';

export const useConfirmEmailState = () => {
    const [ confirmCode, setConfirmCode ] = React.useState('');
    const timer = useCountdownTimer();
    const changeConfirmCode = React.useCallback((value: string) => {
        setConfirmCode(value);
    }, []);

    const resendCode = React.useCallback(async (otpSession: OtpSession) => {
        timer.reset(otpSession.retrySendDelayInSec);

        await resendOtpCode({ urlParams: { sessionId: otpSession.id } });

        timer.start(otpSession.retrySendDelayInSec);
    }, [ timer.reset, timer.start ]);

    return {
        confirmCode,
        changeConfirmCode,
        resendCode,
        timer: timer.seconds
    };
};
